'use strict';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerManager = void 0;
var environment_1 = require("@shared/types/environment");
var wait_1 = require("@shared/utils/wait");
var angular_1 = require("angular");
var jsnlog = __importStar(require("jsnlog"));
var lodash_1 = __importDefault(require("lodash"));
var JL = jsnlog.JL;
/**
 * By default, jsnlog will send logs for every uncaught javascript exception
 * We should prevent this by setting the following handlers
 * See here: http://nodejs.jsnlog.com/Documentation/HowTo/JavascriptErrorHandling
 */
window.onerror = lodash_1.default.constant(false);
window.onunhandledrejection = lodash_1.default.constant(false);
var LOG_LEVELS = {
    INFO: 'info',
    ERROR: 'error',
    WARN: 'warn'
};
// How long to wait before sending log batch to the server
var BATCH_TIMEOUT_MS = 5000;
// Max number of logs to send to the server (protect against dev error, infinite loops, etc.)
var MAX_LOGS = 100;
var metadata;
var batchManager;
window.addEventListener('beforeunload', function (e) {
    if (batchManager) {
        batchManager.sendBatch();
    }
});
var BatchManager = /** @class */ (function () {
    function BatchManager(options) {
        if (!options.loggerPath) {
            throw new Error('BatchManager must be given loggerPath on construction');
        }
        this.logger = JL();
        this.ajaxAppender = JL.createAjaxAppender('appender');
        this.numLogsCreated = 0;
        this.batchTimeoutMs = options.batchTimeoutMs || BATCH_TIMEOUT_MS;
        this.maxLogs = options.maxLogs || MAX_LOGS;
        /* +1 to account for the final MAX_LOGS log */
        var maxLogsToSendToServer = this.maxLogs + 1;
        JL.setOptions({
            maxMessages: maxLogsToSendToServer
        });
        this.ajaxAppender.setOptions({
            /* url for our server to process logs */
            url: options.loggerPath,
            /* how long to wait before sending log batch */
            batchTimeout: this.batchTimeoutMs,
            /* if batchTimeout hasn't exceeded, this is how large batch must be before send */
            batchSize: this.maxLogs,
            /* the maximum number of logs to send in one batch */
            maxBatchSize: maxLogsToSendToServer,
            /* this is called before every request to the server */
            beforeSend: function (xhr, json) {
                json.metadata = metadata;
            }
        });
        this.logger.setOptions({
            appenders: [this.ajaxAppender]
        });
    }
    /**
     * Creates a log and adds it to the queue to be sent to the server later.
     * If the max number of logs have been sent,
     * then add a log for this and cancel future logs sent to the server.
     * @param  {string}  topic - namespace for the logs
     * @param  {string}  level - 'info' | 'error'
     * @param  {any}     payload - the data to be logged
     * @param  {string}  stack - stack trace when triggering the log
     * @return {boolean} - whether the log will be queued
     */
    BatchManager.prototype.log = function (topic, level, payload, stack) {
        if (this.numLogsCreated >= this.maxLogs) {
            var errorMessage = "MAX_LOGS: " + this.numLogsCreated + " logs created. No more logs will be sent";
            console.error(errorMessage);
            if (this.numLogsCreated === this.maxLogs) {
                this.enqueue('logger-service', LOG_LEVELS.ERROR, errorMessage, stack);
            }
            return false;
        }
        this.enqueue(topic, level, payload, stack);
        return true;
    };
    /**
     * This immediately sends any queued logs that haven't already
     * been sent to the server. This is useful to send when the
     * page closes.
     */
    BatchManager.prototype.sendBatch = function () {
        this.ajaxAppender.sendBatch();
    };
    BatchManager.prototype.enqueue = function (topic, level, payload, stack) {
        this.numLogsCreated++;
        try {
            var log = {
                topic: topic,
                level: level,
                payload: payload,
                stack: stack
            };
            this.logger[level](log);
        }
        catch (error) {
            console.error('Error enqueuing log', error);
        }
    };
    return BatchManager;
}());
var LoggerManager = /** @class */ (function () {
    function LoggerManager(topic) {
        this.topic = topic;
        if (!this.topic) {
            throw new Error('topic must be provided on construction');
        }
    }
    LoggerManager.prototype.info = function (payload, stack) {
        if (stack === void 0) { stack = Error().stack; }
        return this.log(LOG_LEVELS.INFO, payload, stack);
    };
    LoggerManager.prototype.error = function (payload, stack) {
        if (stack === void 0) { stack = Error().stack; }
        return this.log(LOG_LEVELS.ERROR, payload, stack);
    };
    LoggerManager.prototype.warn = function (payload, stack) {
        if (stack === void 0) { stack = Error().stack; }
        return this.log(LOG_LEVELS.WARN, payload, stack);
    };
    /**
     * Sends any queued logs.
     * Waits a reasonable amount of time for the request to finish.
     */
    LoggerManager.prototype.sendBatch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        batchManager.sendBatch();
                        return [4 /*yield*/, wait_1.wait(5000)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LoggerManager.prototype.log = function (level, payload, stack) {
        if (!payload || !lodash_1.default.includes(lodash_1.default.values(LOG_LEVELS), level)) {
            throw new Error('payload and level must be defined');
        }
        if (!batchManager) {
            throw new Error('batchManager is not instantiated yet. Wait until angular dependencies have loaded');
        }
        if (lodash_1.default.get(payload, 'error') instanceof Error) {
            // if we try to log a pure js Error, we get an empty object
            payload = lodash_1.default.assign({}, payload, {
                error: payload.error.message
            });
        }
        // Log to console too so that the logs can be viewed with the GE Enhanced Logging feature.
        console[level](this.topic, level, payload, stack);
        return batchManager.log(this.topic, level, payload, stack);
    };
    return LoggerManager;
}());
exports.LoggerManager = LoggerManager;
function initBatchManager(options) {
    batchManager = new BatchManager(options);
}
(function (angularModule) {
    /**
     * @todo remove this after we move off of angular
     * This is currently needed so that angular provides dependencies
     */
    angularModule.factory('pr.loggerService', [
        'rsEnvironment',
        'pr.reportTypeService',
        function (env, reportTypeService) {
            try {
                var userAgent = env.get(environment_1.ENV_VARS.USER_AGENT);
                if (lodash_1.default.isObject(userAgent)) {
                    userAgent = lodash_1.default.pickBy(userAgent, function (val) {
                        // we don't need to log info about what the browser is NOT
                        return val !== false;
                    });
                }
                var container = env.get(environment_1.ENV_VARS.CONTAINER);
                var user = env.get(environment_1.ENV_VARS.USER);
                metadata = {
                    containerId: lodash_1.default.get(container, 'definition._id'),
                    projectId: env.get(environment_1.ENV_VARS.ACTIVE_PROJECT_ID),
                    surveyId: env.get(environment_1.ENV_VARS.ACTIVE_SURVEY_ID),
                    userId: lodash_1.default.get(user, 'userId'),
                    brandId: lodash_1.default.get(user, 'brandId'),
                    userAgent: userAgent
                };
                // do not inject API_ROUTES, because it has some dependencies that use this service
                var reportType = reportTypeService.getReportType();
                var loggerPath = "/reports/" + reportType + "/api/logger";
                initBatchManager({ loggerPath: loggerPath });
            }
            catch (error) {
                // wrap this in a try/catch because this runs for all unit tests
                // and some of the methods above may not be defined
            }
            return {
                initBatchManager: initBatchManager,
                getLoggerManager: function (topic) {
                    return new LoggerManager(topic);
                },
                setJL: function (_JL) {
                    JL = _JL;
                }
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
